import { useTranslation } from 'react-i18next'

import { getQaSelector } from '../../../../../../utils/common'
import { stopPropagation } from '../../../../../../utils/events'
import Button, { BUTTON_HEIGHT_32 } from '../../../../../Button'
import Text from '../../../../../Text'
import { WidgetHeaderContentTitle } from '../../../../../Widget'
import {
  getHasMatchScore,
  getMatchBreakdownCount,
  getMatchScoredCount,
  getMatchScorePercent,
  MATCH_SCORE_RING_SIZE,
  RentalPortalMatchEligibilityBadge,
  RentalPortalMatchScoreRing,
} from '../../../../RentalPortalMatch'
import {
  QA_NAME_APPLICANT_FIT_CHECK_REEVALUATE,
  QA_NAME_APPLICANT_FIT_CHECK_STALE,
} from '../ApplicantFitCheckBlock.constants'

import * as styles from './ApplicantFitCheckBlockTitle.module.css'

function ApplicantFitCheckBlockTitle({
  isReadOnly,
  isReevaluating,
  match,
  title,
  onReevaluate,
  onToggleBreakdown,
}) {
  const { t } = useTranslation()

  function handleToggleBreakdown(event) {
    stopPropagation(event)

    onToggleBreakdown(event)
  }

  function handleReevaluate(event) {
    stopPropagation(event)

    onReevaluate()
  }

  return (
    <div className={styles.ApplicantFitCheckBlockTitle}>
      <WidgetHeaderContentTitle title={title} />
      {match?.eligibility ? (
        <RentalPortalMatchEligibilityBadge
          className={styles.badge}
          match={match}
        />
      ) : null}
      {getHasMatchScore(match) ? (
        <button
          className={styles.ring}
          type='button'
          onClick={handleToggleBreakdown}
        >
          <RentalPortalMatchScoreRing
            score={match.score}
            size={MATCH_SCORE_RING_SIZE.tile}
          />
          <Text className={styles.score}>
            {`${getMatchScorePercent(match.score)} %`}
          </Text>
          <Text isSecondary className={styles.coverage}>
            {t('RentalPortal.MatchScoredCountKey', {
              provided: getMatchBreakdownCount(match),
              total: getMatchScoredCount(match),
            })}
          </Text>
        </button>
      ) : null}
      {match?.stale ? (
        <>
          <Text
            {...getQaSelector({ value: QA_NAME_APPLICANT_FIT_CHECK_STALE })}
            isSecondary
            className={styles.stale}
          >
            {t('RentalPortal.MatchStaleKey')}
          </Text>
          {isReadOnly ? null : (
            <Button.Text
              className={styles.reevaluate}
              disabled={isReevaluating}
              height={BUTTON_HEIGHT_32}
              isLoading={isReevaluating}
              qaName={QA_NAME_APPLICANT_FIT_CHECK_REEVALUATE}
              text={t('RentalPortal.MatchReevaluateBtnKey')}
              onClick={handleReevaluate}
            />
          )}
        </>
      ) : null}
    </div>
  )
}

export default ApplicantFitCheckBlockTitle
